import { render, staticRenderFns } from "./ccKcCensus.vue?vue&type=template&id=35500368&scoped=true&"
import script from "./ccKcCensus.vue?vue&type=script&lang=js&"
export * from "./ccKcCensus.vue?vue&type=script&lang=js&"
import style0 from "./ccKcCensus.vue?vue&type=style&index=0&id=35500368&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35500368",
  null
  
)

export default component.exports